module.exports = __webpack_public_path__ + "img/fa-regular-400.c794369e.svg";